
import React from 'react';
import {Card, Col, Row} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import { FaCopy, FaPen, FaTrash, FaPlusSquare } from 'react-icons/fa';

const OutcomeMeasureCreateTableData = () => {

   

  return (
    <div>

<Card style={{background:'#F6F7F9'}}>


        <div className='bg-dark px-3' style={{paddingTop:'15px', paddingBottom:'1px',background: 'linear-gradient(to top, #11448A 0%, #176CD9 100%)'}} >
            <Table striped="rows" className='clinic-table measure-create-table'>
                <thead className='rounded-2' style={{}}>
                    <tr className='py-0 m-2 bg-white rounded-2'>
                    <th className='ps-2'>Outcome Measure Title</th>
                    <th>Status</th>
                    <th>No. of Questions</th>
                    <th>Last Updated</th>
                    <th>Actions</th>
                    </tr>
                </thead>
            </Table>
        </div>
        <div>
            

        
      <Table striped="rows" className='clinic-table measure-create-table'>
      <tbody>

        <tr>
          <td>Self Esteem</td>
          <td>Active</td>
          <td>09/05/2023</td>
          <td>5</td>
          <td>
          <Link style={{textDecoration:'none',color:'#000'}}>
             <FaPen className='bg-primary text-light p-2  rounded-circle' type='button' style={{width:'29px',height:'29px', background: 'linear-gradient(0deg, rgba(12,42,82,1) 0%, rgba(25,108,216,1) 100%)'}} /> &nbsp;
            Edit
             </Link>
             <FaTrash  type='button' className='text-light p-2 rounded-circle bg-secondary ms-3' style={{width:'29px',height:'29px'}} /> &nbsp; Delete
            </td>
        </tr>

        <tr>
          <td>Gender and Sexual Orientation</td>
          <td>Draft</td>
          <td>09/05/2023</td>
          <td>4</td>
          <td>
          <Link style={{textDecoration:'none',color:'#000'}}>
             <FaPen className='bg-primary text-light p-2  rounded-circle' type='button' style={{width:'29px',height:'29px', background: 'linear-gradient(0deg, rgba(12,42,82,1) 0%, rgba(25,108,216,1) 100%)'}}/ > &nbsp;
            Edit
             </Link>
             <FaTrash  type='button' className='text-light p-2 rounded-circle bg-secondary ms-3' style={{width:'29px',height:'29px'}}/ > &nbsp; Delete
            </td>
        </tr>

        <tr>
          <td>Overdose and Needle Use</td>
          <td>Active</td>
          <td>09/05/2023</td>
          <td>7</td>
          <td>
          <Link style={{textDecoration:'none',color:'#000'}}>
             <FaPen className='bg-primary text-light p-2  rounded-circle' type='button' style={{width:'29px',height:'29px', background: 'linear-gradient(0deg, rgba(12,42,82,1) 0%, rgba(25,108,216,1) 100%)'}}/ > &nbsp;
            Edit
             </Link>
             <FaTrash  type='button' className='text-light p-2 rounded-circle bg-secondary ms-3' style={{width:'29px',height:'29px'}}/ > &nbsp; Delete
            </td>
        </tr>

        <tr>
          <td>Craving and pain</td>
          <td>Active</td>
          <td>09/05/2023</td>
          <td>6</td>
          <td>
          <Link style={{textDecoration:'none',color:'#000'}}>
             <FaPen className='bg-primary text-light p-2  rounded-circle' type='button' style={{width:'29px',height:'29px', background: 'linear-gradient(0deg, rgba(12,42,82,1) 0%, rgba(25,108,216,1) 100%)'}}/ > &nbsp;
            Edit
             </Link>
             <FaTrash  type='button' className='text-light p-2 rounded-circle bg-secondary ms-3' style={{width:'29px',height:'29px'}}/ > &nbsp; Delete
            </td>
        </tr>

        <tr>
          <td>Abstinence Self Efficancy</td>
          <td>Active</td>
          <td>09/05/2023</td>
          <td>6</td>
          <td>
          <Link style={{textDecoration:'none',color:'#000'}}>
             <FaPen className='bg-primary text-light p-2  rounded-circle' type='button' style={{width:'29px',height:'29px', background: 'linear-gradient(0deg, rgba(12,42,82,1) 0%, rgba(25,108,216,1) 100%)'}}/ > &nbsp;
            Edit
             </Link>
             <FaTrash  type='button' className='text-light p-2 rounded-circle bg-secondary ms-3' style={{width:'29px',height:'29px'}}/ > &nbsp; Delete
            </td>
        </tr>

        <tr>
          <td>GAD - 7</td>
          <td>Active</td>
          <td>09/05/2023</td>
          <td>6</td>
          <td>
          <Link style={{textDecoration:'none',color:'#000'}}>
             <FaPen className='bg-primary text-light p-2  rounded-circle' type='button' style={{width:'29px',height:'29px', background: 'linear-gradient(0deg, rgba(12,42,82,1) 0%, rgba(25,108,216,1) 100%)'}}/ > &nbsp;
            Edit
             </Link>
             <FaTrash  type='button' className='text-light p-2 rounded-circle bg-secondary ms-3' style={{width:'29px',height:'29px'}}/ > &nbsp; Delete
            </td>
        </tr>
       
      </tbody>
    </Table> 

    </div>

    <Row className='my-5 px-3 text-end'>
        <Col className='text-end'>
        <Link 
                type="submit" 
                variant="contained"
                to='/dashboard/OutcomeMeasure' 
                className='text-light btn'
                style={{background: 'linear-gradient(to top, #11448A 0%, #176CD9 100%)', 
                        padding:'5px 25px',
                        border:'none', 
                        boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 6px -1px, rgba(0, 0, 0, 0.06) 0px 2px 4px -1px'}}>Create New
            </Link>  
        </Col>
    </Row>
    </Card>
    </div>
  )
}

export default OutcomeMeasureCreateTableData

